import {useState, useEffect} from 'react';
import IgvBrowser from '../../../../../components/IGV/IGVBrowser'
import * as c from '../../../../../constants.jsx';
import axios from "axios";
import Grid from '@mui/material/Grid';
import ActionAlert from "../../../../../components/Alert/ActionAlert.jsx";
import Box from '@mui/material/Box';
import { useTheme } from "@mui/material";


export default function IgvApp() {


const theme = useTheme();
const url_genfiles = `${c.API_URL}/api/genarchive` 

const [data, setData] = useState([])
const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
useEffect(() => {  

  setLoading(true)
  axios.get(url_genfiles)
      .then((res) => {
        setData(res.data)
        setLoading(false)
      })
      .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          setError(error.response.data);
        } else if (error.request) {
          // The request was made but no response was received
          setError("The request was made but no response was received.");
        } else {
          // Something happened in setting up the request that triggered an Error
          setError("Error: " + error.message);
        }
          });

    }, []);



  return (
  <>
  
  {loading && <span> Please wait ... fetching data </span>}

   {theme.palette.mode === "light" ? ( 

    

      <Box sx={{ p: '2rem', bgcolor: 'grey.C50', borderRadius: '8px'}}>            
              <>
              
              {data.map((i, index) => <IgvBrowser key={index} sample= {i.sample} cram={i.CRAM_file} crai={i.CRAM_index_file} /> )} 
              </>
      </Box>
    
      ):(

        <Box sx={{ p: '2rem', bgcolor: 'greydark.C50', borderRadius: '8px'}}>          
              <>
              
              {data.map((i, index) => <IgvBrowser key={index} sample= {i.sample} cram={i.CRAM_file} crai={i.CRAM_index_file} /> )} 
              </>
        </Box>

      )
   }

  {error && (
    <Grid mt={2} mb={1} justifyContent="center" container spacing={1}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <ActionAlert severity="error" message={error.message} />
      </Grid>
    </Grid>
)}

</>
  );
};

